export const ZERO_PRICE = 0;
